import menuToggle from './navbar';

import {
	fileInputContainers,
	fileInputs,
	inputFields,
	removeItemIcons,
} from './inputFields';
import teamCardSlider from './teamCardSlider';
import './partnersInfo';
import testimonySlider from './testimonialSlider';
import expandableList from './expandableList';
import modal from './modal';
import trustpilot from './trustpilot';
import table from './table';
import productDetails from './productDetails';
import './insuranceScenario';
import './customerReviews';
import './ratgeberTeaser';
import './accordionPricingTable';
import './insuranceType';
import { initThemeIcons } from './themeIcon';
export { menuToggle };

const successModal = document.querySelector('.success-modal');

window.addEventListener('DOMContentLoaded', (event) => {
	initThemeIcons();

	if (event.target.URL) {
		const message = event.target.URL.split('#')[1];
		if (message === 'success') successModal.style.display = 'block';
	}

	if (window.matchMedia('(max-width: 768px)').matches) {
		document.querySelectorAll('h1').forEach((el) => {
			if (el.textContent.length > 80) {
				el.setAttribute('data-long', 'true');
			}
		});
	}
});
